import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/AuthContext";
import HostHome from "./pages/HostHome";
import GuestLanding from "./pages/GuestLanding";
import UploadPage from "./pages/UploadPage";
import GalleryPage from "./pages/GalleryPage";
import MediaDetail from "./pages/MediaDetail";
import MessageHostPage from "./pages/MessageHostPage";
import MessagesInbox from "./pages/MessagesInbox";
import ActivityPage from "./pages/ActivityPage";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            <Route path="/" element={<HostHome />} />
            <Route path="/:slug" element={<GuestLanding />} />
            <Route path="/:slug/upload" element={<UploadPage />} />
            <Route path="/:slug/gallery" element={<GalleryPage />} />
            <Route path="/:slug/media/:id" element={<MediaDetail />} />
            <Route path="/:slug/message" element={<MessageHostPage />} />
            <Route path="/:slug/messages" element={<MessagesInbox />} />
            <Route path="/:slug/activity" element={<ActivityPage />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
